module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA70lEQVRYR+2W4Q3CIBCFv66jSziF66jrOIVL6DzmmjZBLfDuiFKTNuEP5d77gDtgoPM3dPZnA1jtChwAa1fg0ZgnO+AI3Kb2IpdbgTNwAu5TcBTCzG0Se+ACmK4EkAZGISSNUg5IApntkWNrSSgLJSCumBqA6XoEPWNHZgVAhXCbewBqECFzL0AOwvrnUnNXjLoFabK/z9b+WZ27zSMrMIOkENYXMv9bgK5bsJTtP0vCUql9vQwVA2XMx9WhlKFH2DNWOordgs67o3gXRMyXzoniGZHbghZzF8Rqn2TdH6WND2E9XClDXS0wcgPovgJPQhpyIR1G2Z8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 1